import api from 'Application/api/api';

const createTranche = async (signal, values) => {
	const response = await api.post('/tranches', values, {
		signal,
	});

	if (!response || !response.data) {
		return response;
	}

	return {
		...response,
	};
};

export default createTranche;
